import { Controller } from "@hotwired/stimulus"

// Recarrega o turbo-frame da sugestão da IA enquanto o pedido está na fila. A URL já vem com o
// número da próxima tentativa, então cada recarga é uma URL nova (o Turbo ignora `src` repetido) e
// o servidor sabe quando parar de esperar. Polling e não broadcast: com broadcast, um job rápido
// pode terminar antes de a página assinar o canal, e o spinner ficaria eterno.
export default class extends Controller {
  static values = { url: String, delay: { type: Number, default: 2000 } }

  connect() {
    this.timer = setTimeout(() => {
      const frame = this.element.closest("turbo-frame")
      if (frame) frame.src = this.urlValue
    }, this.delayValue)
  }

  disconnect() {
    clearTimeout(this.timer)
  }
}
